import React from "react";

import MessageContext from "../contexts/MessageContext";

const useMessage = () => React.useContext(MessageContext);

export default useMessage;
